// useAxiosRequest.js

import axios, {AxiosError, AxiosRequestConfig, Method} from 'axios'
import {useCallback} from 'react'
import {MODAL_TYPES, useMessageModalContext} from '.'

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS'
}

const API_URL = process.env.REACT_APP_API_URL

export const useAncientRequest = () => {
  const {showModal} = useMessageModalContext()

  const axiosRequest = useCallback(
    async (
      method: HttpMethod,
      url: string,
      data?: any,
      successMessage?: string,
      config?: AxiosRequestConfig
    ): Promise<any> => {
      try {
        const compiledUrl: string = `${API_URL}${url}`
        const response = await axios({method, url: compiledUrl, data, ...config})
        if (successMessage) showModal(MODAL_TYPES.SUCCESS_TOAST, {message: successMessage})

        return response
      } catch (exception) {
        const err = exception as AxiosError
        var error = {
          title: 'Error',
          userMessage: 'An error occurred, please contact Benchmarking Administration.',
          errorCleanMessage: err.message,
          stackTrace: '',
        }
        
        //There are some cases where we return blobs which kind of messes with error output. If its a blob, we need to convert the results.
        if (err?.response?.data instanceof Blob && err.response.data.type === 'application/json') {
          const reader = new FileReader()
          reader.onload = async () => {
            try {
              const jsonError = JSON.parse(reader.result as string)
              error = jsonError
              showModal(MODAL_TYPES.ERROR_MODAL, error)
            } catch (e) {
              showModal(MODAL_TYPES.ERROR_MODAL, error)
            }
          }
          reader.onerror = () => {
            showModal(MODAL_TYPES.ERROR_MODAL, error)
          }
          reader.readAsText(err.response.data)
          return Promise.reject(error)
        }

        if (err?.response?.data !== undefined) error = err.response.data
        showModal(MODAL_TYPES.ERROR_MODAL, error)
        throw error
      }
    },
    [showModal]
  )

  return axiosRequest
}
